import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = (props) => {
  const { changeLanguage } = useLanguage();
  const allLanguages = [
    {
      language: 'English',
      code: 'en',
      image: 'images/language1.svg',
    },
    {
      language: '繁體中文',
      code: 'zh',
      image: 'images/language2.svg',
    },
  ];
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'en');
  const handleChangeLanguage = (newLanguage) => {
    if (currentLanguage !== newLanguage) {
      changeLanguage(newLanguage);
      setCurrentLanguage(newLanguage);
    }
  };
  useEffect(() => {
    const updateLang = (lng) => {
      document.documentElement.lang = lng;
    };
    updateLang(i18n.language);
    i18n.on('languageChanged', updateLang);

    return () => {
      i18n.off('languageChanged', updateLang);
    };
  }, []);
  return (
    <>
      <button
        type="button"
        onClick={props.handleLangeChangeClick}
        className="language"
      >
        <img
          src={
            props?.color === 'white'
              ? 'images/language.svg'
              : 'images/language-convert.svg'
          }
          alt=""
        />
      </button>
      {props.openLangChange && (
        <div className="language-change">
          <ul>
            {allLanguages.map((langObj, langIndex) => (
              <li
                key={langIndex}
                onClick={() => handleChangeLanguage(langObj.code)}
              >
                <div className="">
                  <img src={langObj.image} alt="" className="pe-1" />
                  {langObj.language}
                </div>
                {currentLanguage === langObj.code && (
                  <img src="images/checkimg.svg" alt="" />
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default LanguageSwitcher;
